// eslint-disable-next-line vue/valid-template-root
<template>
  <div></div>
</template>

<script>
import { Routes } from '~/constants/routes';
import auth0Client from '~/plugins/authClient';

export default {
  name: 'LoginPage',

  components: {},

  beforeRouteEnter(to, from, next) {
    // redirect to "home" if user is already authenticated
    if (auth0Client.isAuthenticated.value) {
      next({ path: Routes.Home });
    } else {
      auth0Client.loginWithRedirect();
    }
  },
};
</script>
